import { createContext } from "react";

export const GlobalVars = createContext(
    {
        language: 0,//0 esp, 1 eng    
        sincoToken: null,               
    }
);